/**
 * TreeView component content/translations
 * Requirements: 16.1, 16.2
 */

const content = {
  title: "Tree View",
  // KPI Labels - Req 16.1
  personalPV: "PPV",
  groupPV: "GPV",
  bonusPercent: "%",
  percent: "%",

  // Badge Text - Req 16.2
  aboBadge: "ABO",
  paboBadge: "PABO",

  // Control buttons
  zoomIn: "Zoom In",
  zoomOut: "Zoom Out",
  reset: "Reset",
  expandAll: "Expand All",
  collapseAll: "Collapse All",
  fullscreen: "Fullscreen",
  exitFullscreen: "Exit Fullscreen",

  // Loading and states
  loading: "Loading...",
  errorLoadingData: "Error loading tree data",

  // Search
  searchPlaceholder: "Search by ABO number or name",
  searchLabel: "Search",
  noResults: "No results found",
  clearSearch: "Clear search",

  // Detail panel
  detailPanelTitle: "ABO Details",
  close: "Close",
  profile: "Profile",
  kpis: "Key Performance Indicators",
  name: "Name",
  aboNumber: "ABO Number",
  country: "Country",
  awardLevel: "Award Level",
  groupCount: "Group Count",

  infoKey: {
    title: "Info Key",
    internationalDownline: "International Downline",
    platinumOrAbove: "Platinum or Above",
    goldProducer: "Gold Producer",
    silverSponsor: "Silver Sponsor",
    silverProducer: "Silver Producer",
  },

  // Modal action links
  viewProfile: "View Profile",
  expandGroup: "Expand Group",
  collapseGroup: "Collapse Group",
  addToWatchlist: "Add to Watchlist",
  removeFromWatchlist: "Remove from Watchlist",
  updatingWatchlist: "Updating...",
  viewPerformanceHistory: "Performance History",
  viewDownlineLos: "View Downline LOS",
  undoDownlineLos: "Undo View Downline LOS",

  confidentialUser: "Confidential User",

  // External links
  externalLinks: {
    anaVolumeDetails: "Volume Details Report",
  },

  noDownlinesInView: "You do not have any downlines to display in this view",

  // Accessibility
  accessibilityLabels: {
    treeViewCanvas: "Line of Sponsorship Tree View",
    zoomInButton: "Zoom in",
    zoomOutButton: "Zoom out",
    resetButton: "Reset view",
    expandAllButton: "Expand all nodes",
    collapseAllButton: "Collapse all nodes",
    fullscreenButton: "Toggle fullscreen",
    filterButton: "Filter international ABOs",
    filterButtonActive: "Filter international ABOs, {count} active",
    infoKeyButton: "Open info key",
    closeDetailPanel: "Close detail panel",
    expandNode: "Expand node",
    collapseNode: "Collapse node",
    selectNode: "View node details",
    closeModal: "Close modal",
  },
} as const;

export default content;
